import React from 'react';
import { CheckIcon } from 'lucide-react';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="beneficios" data-id="element-14" data-mp="bpcall2bcr5">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-15" data-mp="3ip5b7wvwixwx">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-16" data-mp="3npb57jpn8wi6">
          El comprador informado
        </p>
        <h2 id="beneficios" className="mt-3 max-w-3xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-17" data-mp="38qzctp9b09wt">
          Lo que vas a poder hacer desde el primer día
        </h2>

        <ul className="mt-10 grid gap-x-10 sm:grid-cols-2" data-id="element-18" data-mp="2zt6tma0goi45">
          {benefits.map(benefit => <li key={benefit} className="flex gap-3 border-b border-ink-800 py-4 text-[15px] leading-relaxed text-slate-300" data-id="element-19" data-mp="34qp3c2maz1d7">
              <CheckIcon className="mt-1 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-20" data-mp="12y0zbr1u49wd" />
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}